import Cascader from './Cascader'

/* istanbul ignore next */
Cascader.install = function (app) {
  app.component(Cascader.name, Cascader)
}

export default Cascader
